module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "objectPopup",
    class: {
      rightPaneOpen: _vm.showDiscussion
    }
  }, [_c('div', {
    staticClass: "overlay doNotDesactiveOnClick",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "right"
  }, [(_vm.sharedObject && !_vm.error) ? [_c('i', {
    staticClass: "fa fa-globe",
    class: {
      "text-muted": !_vm.sharedObject.public
    },
    attrs: {
      "role": "button",
      "title": _vm.$t("sharedObjectViewer.titles.togglePublish")
    },
    on: {
      "click": _vm.togglePublish
    }
  }), _c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "role": "button",
      "title": _vm.$t("sharedObjectViewer.titles.toShareManager")
    },
    on: {
      "click": _vm.openSharedObjectMembers
    }
  }), (_vm.sharedObject.kind == "file" || _vm.sharedObject.kind == "folder") ? _c('i', {
    staticClass: "fa fa-folder-open",
    attrs: {
      "role": "button",
      "title": _vm.$t("sharedObjectViewer.titles.openParentFolder")
    },
    on: {
      "click": _vm.openInFolder
    }
  }) : _vm._e(), (_vm.nodeIsDownloadable(_vm.sharedObject) && _vm.downloadLinkIsReady) ? _c('a', {
    attrs: {
      "href": _vm.downloadLinkUrl,
      "title": _vm.$t("sharedObjectViewer.titles.download"),
      "download": "download"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()] : _vm._e(), _c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "title": _vm.$t("sharedObjectViewer.titles.close"),
      "role": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  })], 2), (_vm.sharedObject) ? [(_vm.hasCollection) ? _c('div', {
    staticClass: "left"
  }, [_c('a', {
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToPrevious
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _c('a', {
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "0",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToNext($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]), _c('a', [_vm._v(_vm._s(_vm.index + 1) + " / " + _vm._s(_vm.collection.length))])]) : _vm._e(), _c('vue-object-img', {
    attrs: {
      "object": _vm.sharedObject.group
    }
  }), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.sharedObject.name))])] : _vm._e()], 2), _c('div', {
    ref: "contents",
    staticClass: "contents doNotDesactiveOnClick",
    attrs: {
      "id": "objectPopupContents"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal($event)
      }
    }
  }, [_c('div', {
    staticClass: "body",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal($event)
      }
    }
  }, [(_vm.sharedObject) ? [(_vm.sharedObject.loading) ? _c('div', {
    staticClass: "inViewer",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal($event)
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [(!_vm.error) ? [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _c('br'), _vm._v(_vm._s(_vm.$t("globals.loading")))] : _vm._e(), (_vm.error) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t('sharedObjectViewer.error')) + " " + _vm._s(_vm.$t('sharedObjectViewer.haveYouAccess')))]) : _vm._e()], 2)]) : (_vm.sharedObject.kind == 'event') ? _c('div', {
    staticClass: "body-padding-top"
  }, [_c('accordion', {
    staticClass: "eventsList",
    attrs: {
      "injected": true,
      "container": "#objectPopupContents",
      "thresold": 50
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal($event)
      }
    }
  }, [_c('detailled-event', {
    attrs: {
      "event": _vm.sharedObject,
      "initial-active": true,
      "initial-stay-active": true,
      "injected": false
    }
  })], 1)], 1) : (_vm.sharedObject.kind == 'poll') ? _c('div', {
    staticClass: "body-padding-top"
  }, [_c('accordion', {
    staticClass: "pollsList",
    attrs: {
      "injected": true,
      "container": "#objectPopupContents",
      "thresold": 50
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal($event)
      }
    }
  }, [_c('poll', {
    attrs: {
      "poll": _vm.sharedObject,
      "initial-active": true,
      "initial-stay-active": true,
      "injected": false
    }
  })], 1)], 1) : (_vm.sharedObject.kind == 'conversation') ? _c('div', {
    staticClass: "body-padding-top"
  }, [_c('accordion', {
    staticClass: "mailbox",
    attrs: {
      "injected": true,
      "container": "#objectPopupContents",
      "thresold": 50
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal($event)
      }
    }
  }, [_c('conversation', {
    attrs: {
      "conversation": _vm.sharedObject,
      "initial-active": true,
      "initial-stay-active": true,
      "injected": false
    }
  })], 1)], 1) : [_c('div', {
    staticClass: "inViewer",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal($event)
      }
    }
  }, [(!_vm.inQuotaOrder) ? [_c('div', {
    staticClass: "exceededQuota"
  }, [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$t("sharedObjectViewer.exceededQuota.title")))]), _c('p', [_vm._v(_vm._s(_vm.$t("sharedObjectViewer.exceededQuota.description1")))]), _c('p', [_vm._v(_vm._s(_vm.$t("sharedObjectViewer.exceededQuota.description2")) + " ")]), _c('div', {
    staticClass: "alert alert-success"
  }, [(_vm.bestRange.price != 0) ? _c('p', {
    staticClass: "bpadding"
  }, [_vm._v(_vm._s(_vm.$t("sharedObjectViewer.exceededQuota.incitation", {
    price: _vm.bestRange.price,
    space: _vm.hrS(_vm.bestRange.space * 1024 * 1024)
  })))]) : _vm._e(), _c('div', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.goToGroupAccount
    }
  }, [_vm._v(_vm._s(_vm.$t("sharedObjectViewer.exceededQuota.button")))])])])] : (_vm.sharedObject.deleted) ? [_c('div', {
    staticClass: "deletedFile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._m(1), _c('h3', [_vm._v(_vm._s(_vm.$t("sharedObjectViewer.deletedItem.title")))]), _c('p', [_vm._v(_vm._s(_vm.$t("sharedObjectViewer.deletedItem.description")))])])])] : [(_vm.nodeIsImage(_vm.sharedObject)) ? _c('div', {
    staticClass: "imageView",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.downloadLinkIsReady) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.downloadLinkUrl),
      expression: "downloadLinkUrl"
    }]
  }) : _vm._e()]) : _vm._e(), (_vm.nodeIsAudio(_vm.sharedObject) && !_vm.error) ? _c('div', {
    staticClass: "audioView"
  }, [(_vm.downloadLinkIsReady) ? _c('audio', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls": "controls",
      "autoplay": "autoplay"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.downloadLinkUrl,
      "type": "audio/mp3"
    },
    on: {
      "error": _vm.setError
    }
  }), _vm._v(_vm._s(_vm.$t("sharedObjectViewer.errorRuntime")))]) : _vm._e()]) : _vm._e(), (_vm.nodeIsPDF(_vm.sharedObject)) ? _c('div', {
    staticClass: "pdfView"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.downloadLinkUrl
    }
  })]) : _vm._e(), (_vm.nodeIsYoutubeLink(_vm.sharedObject)) ? _c('div', {
    staticClass: "videoView"
  }, [(_vm.nodeIsYoutubeLink(_vm.sharedObject)) ? _c('iframe', {
    attrs: {
      "allowfullscreen": "allowfullscreen",
      "frameborder": "0",
      "src": _vm.getNodeYoutubeLink(_vm.sharedObject) + '?rel=0&autoplay=1'
    }
  }) : _vm._e()]) : _vm._e(), (_vm.nodeIsLink(_vm.sharedObject)) ? _c('div', {
    staticClass: "linkView text-center"
  }, [(_vm.nodeIsLink(_vm.sharedObject)) ? _c('a', {
    attrs: {
      "href": _vm.sharedObject.url,
      "target": "_blank",
      "rel": "noreferrer"
    }
  }, [_c('i', {
    staticClass: "fa fa-link fa-2x"
  }), _c('br'), _vm._v(_vm._s(_vm.sharedObject.url))]) : _vm._e()]) : _vm._e(), (!_vm.hasFileViewer || _vm.error) ? _c('div', {
    staticClass: "defaultView"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t('sharedObjectViewer.error')))]) : _vm._e(), _vm._v(_vm._s(_vm.$t('sharedObjectViewer.noVisualisation'))), _c('br'), (_vm.nodeIsDownloadable(_vm.sharedObject) && _vm.downloadLinkIsReady) ? _c('a', {
    staticClass: "btn",
    attrs: {
      "href": _vm.downloadLinkUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" " + _vm._s(_vm.$t('sharedObjectViewer.download')))]) : _vm._e()]) : _vm._e()]], 2)]] : _vm._e(), (!_vm.sharedObject) ? [_c('div', {
    staticClass: "inViewer"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t('sharedObjectViewer.error')) + " " + _vm._s(_vm.$t('sharedObjectViewer.haveYouAccess')))]) : _vm._e()])] : _vm._e()], 2)]), (_vm.showDiscussion) ? _c('div', {
    staticClass: "rightPane"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "15px",
      "top": "20px",
      "z-index": "1"
    }
  }, [(_vm.sharedObject.conversation) ? _c('router-link', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "to": {
        query: {
          m: 'shared',
          k: 'conversation',
          i: _vm.sharedObject.conversation.id || _vm.sharedObject.conversation
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-expand"
  })]) : _vm._e()], 1), _c('conversation-on-shared-object', {
    attrs: {
      "shared-object": _vm.sharedObject
    }
  }), _c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    }
  })], 1) : _vm._e(), (_vm.canShowDiscussion) ? _c('a', {
    staticClass: "btn btn-default fixedBottomRight",
    on: {
      "click": function($event) {
        _vm.rightPaneOpen = !_vm.rightPaneOpen
      }
    }
  }, [(!_vm.showDiscussion) ? _c('i', {
    staticClass: "fa fa-comments"
  }) : _vm._e(), (_vm.showDiscussion) ? _c('i', {
    staticClass: "fa fa-arrow-right"
  }) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("sharedObjectViewer.toggleConversation")))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-bell"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-ban"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb12789a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SharedObjectViewer.vue
// module id = 1289
// module chunks = 1